import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

export const Pagination = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 32px;
`;

export const PaginationNavLink = styled(NavLink)`
  align-items: center;
  display: flex;
  margin: 0 16px;
`;
